import { Component } from '@theme/component';

/**
 * A custom element that renders a video background.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} videoSources - The video sources.
 * @property {HTMLVideoElement} videoElement - The video element.
 *
 * @extends Component<Refs>
 */
export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement'];

  connectedCallback() {
    super.connectedCallback();

    const { videoSources, videoElement } = this.refs;

    const loadVideo = () => {
    for (const source of videoSources) {
    const { videoSource } = source.dataset;

    if (videoSource) source.setAttribute('src', videoSource);
    }

    videoElement.load();
    };

    if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
    if (entry.isIntersecting) {
    loadVideo();
    observer.disconnect();
    }
    }
    }, { rootMargin: '1000px' });

    observer.observe(this);
    } else {
    loadVideo();
    }
    }
  }

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}
